import * as React from "react";
import { Props } from "../types";
import { ImageModal } from "./ImageModal";
import { createPortal } from 'react-dom';
import { GalleryImage } from "./GalleryImage";
import * as objectHash from "object-hash";

export const Gallery = (props: Props.Gallery) => {
    const [showModal, setShowModal] = React.useState<boolean>(false);
    const [activeImageIndex, setActiveImageIndex] = React.useState<number>(-1);
    const handleClick = (e,activeIndex) => {
        e.preventDefault();
        setActiveImageIndex(activeIndex);
    }

    React.useEffect(() => {
        setShowModal(activeImageIndex!==-1);
    },[activeImageIndex]);

    return <ul className={`c-wp-gallery__container c-wp-gallery__container__columns--${props.columns}`}>
        {createPortal(
            <ImageModal show={showModal} onClose={() => setActiveImageIndex(-1)} imageIndex={activeImageIndex}
                        galleryImages={props.galleryImages}/>,
            document.body
        )}
        {props.galleryImages.map((image, index) => {
            return <li key={`gallery_${objectHash(props.galleryImages)}_${index}`} className={'c-wp-gallery__container__item'}>
                <GalleryImage galleryImages={props.galleryImages} imageIndex={index} onClick={handleClick} />
            </li>
        })}
    </ul>
}
